import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../context-api/nav-context";

const ComingSoon = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="section-wrapper" onMouseOver={closeNavbarMenu}>
      <div className="coming-soon_container">
        <h1 className="title">Boiler Cover Coming Soon 2022!!!</h1>
        <p className="coming-home_para">
          Check back soon. We'll be offering the best boiler cover plans for
          homeowners and landlords!
        </p>
        <Link to="/" className="btn-hero btn-quote">
          Return Home
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
